/**
 * Get active nutrition goal from client (goal.active === true or first goal).
 * Returns null if no goals.
 * Checks both client.nutritionGoals and client.clientData?.nutritionGoals (mobile/coach shapes).
 */
export function getActiveNutritionGoal(client) {
  const goals = client?.nutritionGoals ?? client?.clientData?.nutritionGoals;
  if (!goals?.length) return null;
  const active = goals.find((g) => g.active === true);
  return active ?? goals[0];
}

/**
 * Calories from macro goal: proteins*4 + carbs*4 + fats*9.
 */
export function getkCal(goal) {
  if (!goal) return 0;
  const p = Number(goal.proteins) || 0;
  const c = Number(goal.carbs) || 0;
  const f = Number(goal.fats) || 0;
  return Math.round(p * 4 + c * 4 + f * 9);
}

/**
 * Current calories from report macros (proteins*4 + carbs*4 + fats*9).
 */
export function getkCalFromMacros(reportData) {
  if (!reportData) return 0;
  const p = Number(reportData.proteins) || 0;
  const c = Number(reportData.carbs) || 0;
  const f = Number(reportData.fats) || 0;
  return Math.round(p * 4 + c * 4 + f * 9);
}
